import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';


let apiPromiseCache = {};

const fetchWithCache = (url) => {
  if (!apiPromiseCache[url]) {
    apiPromiseCache[url] = axios.get(url).catch(err => {
      delete apiPromiseCache[url];
      throw err;
    });
  }
  return apiPromiseCache[url];
};

export const getDefects = ({ kulModelKodu, garantiTipi, WorkOrderDetails }) => {
  return fetchWithCache(`/GetSiriusDefects/${kulModelKodu}/${garantiTipi}`);
};


export const getMaterials = ({
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
  uyil,
  udonem,
  WorkOrderIdParam
}) => {
  const SessionUser = getUser();
  // Bypass cache for materials to ensure fresh data on each request
  return axios.get(
    `/GetSiriusMaterials/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${WorkOrderIdParam}`
  );
};

export const getHistoricalMaterials = ({
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
  uyil,
  udonem
}) => {
  return fetchWithCache(
    `/GetArtemisTarihselAgac/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}`
  );
};

export const getLabours = ({ kulModelKodu, garantiTipi, hizmetKodu, WorkOrderId, refreshVatPrices = false }) => {
  const SessionUser = getUser();
  const url = `/GetSiriusLabours/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${WorkOrderId}`;
  // Only a VAT change invalidates this work order's cached prices.
  if (refreshVatPrices) delete apiPromiseCache[url];
  return fetchWithCache(url);
};
